import { useState } from 'react';

import { PFAND_ARTEN, pfandPosition, type PfandArt } from '../pfand';
import { formatiereEuro, type Position } from '../warenkorb';

/** Pfand berechnen oder Leergut zurücknehmen: Art antippen, Stückzahl, übernehmen. */
export function PfandDialog(props: { leergut: boolean; onFertig: (p: Position | null) => void }) {
  const [art, setArt] = useState<PfandArt>(
    PFAND_ARTEN[0] ?? { bezeichnung: 'Pfand', cent: 25, steuersatz: '0' },
  );
  const [menge, setMenge] = useState(1);
  const summe = art.cent * menge;
  return (
    <div className="zahlung-dialog" role="dialog" aria-modal="true">
      <div className="karte">
        <h2>{props.leergut ? 'Leergut zurücknehmen' : 'Pfand'}</h2>
        <div className="chips" role="group" aria-label="Pfandart">
          {PFAND_ARTEN.map((a) => (
            <button
              key={a.bezeichnung}
              type="button"
              className={a.bezeichnung === art.bezeichnung ? 'aktiv' : ''}
              onClick={() => {
                setArt(a);
              }}
            >
              {a.bezeichnung} · {formatiereEuro(a.cent)} €
            </button>
          ))}
        </div>
        <div className="zeile" style={{ alignItems: 'center', justifyContent: 'center' }}>
          <span className="stepper">
            <button
              type="button"
              aria-label="Weniger"
              onClick={() => {
                setMenge((m) => Math.max(1, m - 1));
              }}
            >
              −
            </button>
            <span>{menge}</span>
            <button
              type="button"
              aria-label="Mehr"
              onClick={() => {
                setMenge((m) => Math.min(999, m + 1));
              }}
            >
              +
            </button>
          </span>
          <div className="betrag">
            {props.leergut ? '−' : ''}
            {formatiereEuro(summe)} €
          </div>
        </div>
        <p className="hinweis">
          {art.steuersatz === '0'
            ? 'Einwegpfand ist ein durchlaufender Posten (0 %).'
            : 'Mehrwegpfand folgt dem Steuersatz des Getränks (20 %).'}
          {props.leergut && ' Leergut wird vom Bon abgezogen – nur zusammen mit einem Einkauf.'}
        </p>
        <div className="zeile" style={{ justifyContent: 'center' }}>
          <button
            className="taste gross"
            onClick={() => {
              props.onFertig(pfandPosition(art, menge, props.leergut));
            }}
          >
            {props.leergut ? 'Leergut abziehen' : 'Pfand hinzufügen'}
          </button>
          <button
            className="taste zweit"
            onClick={() => {
              props.onFertig(null);
            }}
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
}
